module.exports = __webpack_public_path__ + "static/img/limit_01.7dd7b779.svg";